import React from 'react';
import { Divider, Skeleton, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  collectorIcon: {
    alignSelf: 'center',
    display: 'flex',
    height: '210px',
    width: '210px',
    borderRadius: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`
  },
  leftContainer: {
    width: '210px',
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(4)
  },
  divider: {
    display: 'flex',
    margin: theme.spacing(3, -4, 2, -4)
  },
  installedDate: {
    marginTop: theme.spacing(2)
  },
  connected: {
    display: 'flex',
    alignSelf: 'center',
    marginTop: theme.spacing(-1.25),
    width: theme.spacing(10),
    borderRadius: theme.spacing(0.5)
  },
  publishedBy: {
    marginTop: theme.spacing(2)
  },
  disconnect: {
    height: theme.spacing(4.5),
    borderRadius: theme.spacing(2.5),
    marginTop: theme.spacing(2.1)
  },
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  desktopLink: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    borderRadius: theme.spacing(2.5),
    padding: theme.spacing(1),
    textTransform: 'uppercase'
  },
  loading: {
    display: 'flex',
    justifyContent: 'flex-start',
    height: 530,
    margin: theme.spacing(-2.5, 0)
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(4),
    paddingTop: theme.spacing(2.5),
    width: '100%'
  },
  verticalDivider: {
    backgroundColor: theme.palette.grey[100]
  },
  actions: {
    justifyContent: 'end',
    display: 'flex',
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(1)
  },
  actionButton: {
    height: theme.spacing(5),
    margin: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1,
    flexShrink: 1
  },
  settingsRowContent: {
    marginTop: theme.spacing(2),
    alignContent: 'flex-start',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 300px)',
    width: '100%'
  },
  title: {
    margin: theme.spacing(0.5, 0)
  }
}));

export const CompanyCollectorSettingsDialogSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.loading}>
      <div className={classes.leftContainer}>
        <div className={classes.container}>
          <Skeleton variant="rectangular" className={classes.collectorIcon} />
          <Typography className={classes.connected} variant="caption">
            <Skeleton width={'100%'} />
          </Typography>
          <Skeleton variant="rectangular" className={classes.disconnect} />

          <div className={classNames(classes.publishedBy)}>
            <Typography variant="body2">
              <Skeleton width={'50%'} />
            </Typography>
          </div>

          <Typography variant="body2">
            <Skeleton width={'70%'} />
          </Typography>

          <Divider className={classes.divider} orientation="horizontal" />

          <Typography variant="body2">
            <Skeleton width={'50%'} />
          </Typography>

          <Typography variant="body2">
            <Skeleton width={'50%'} />
          </Typography>

          <Typography variant="body2">
            <Skeleton width={'70%'} />
          </Typography>

          <Typography className={classes.installedDate} variant="caption">
            <Skeleton width={'50%'} />
          </Typography>
        </div>
      </div>

      <div>
        <Divider className={classes.verticalDivider} orientation="vertical" />
      </div>
      <div className={classes.rightContainer}>
        <Typography variant="h6" className={classes.title}>
          <Skeleton width={'20%'} />
        </Typography>

        <div className={classes.settingsRowContent} />
        <Skeleton height={40} />
        <div className={classes.spacer} />
        <div className={classes.actions}>
          <Skeleton className={classes.actionButton} width={'6%'} />
          <Skeleton className={classes.actionButton} width={'6%'} />
        </div>
      </div>
    </div>
  );
};
